/* eslint-disable class-methods-use-this */
/* eslint-disable no-misleading-character-class */
/* eslint-disable no-param-reassign */
// eslint-disable-next-line no-unused-vars
class GiftBuilder extends Core {
	constructor() {
		super();
		this.cardsUrl = "/cards/greeting-cards/index.json";
		this.documentHtml = document.documentElement;
		this.payloadItems = [];
		this.mainItem = null;
		this.cardMessage = null;
		this.cardVariantId = null;
		this.activeStep = 0; // starts on 0
		this.maxMessageLength = 500;
		this.autoAdvanceTime = 750;
		this.sortCards = true;
		this.cleanEmojis = true;
		this.renderedItems = [];

		this.emojiRegex =
			/\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D[\uD83D\uDC66\uD83D\uDC67])|\uD83D\uDC68(?:\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68[\uD83C\uDFFB-\uD83C\uDFFE]|[\uD83C\uDF3E\uD83C\uDF73\uD83C\uDF7C\uD83C\uDF93\uD83C\uDFA4\uD83C\uDFA8\uD83C\uDFEB\uD83C\uDFED\uD83D\uDCBB\uD83D\uDCBC\uD83D\uDD27\uD83D\uDD2C\uD83D\uDE80\uD83D\uDE92\uD83E\uDDAF-\uD83E\uDDB3\uD83E\uDDBC\uD83E\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68[\uD83C\uDFFB-\uD83C\uDFFD\uD83C\uDFFF]|[\uD83C\uDF3E\uD83C\uDF73\uD83C\uDF7C\uD83C\uDF93\uD83C\uDFA4\uD83C\uDFA8\uD83C\uDFEB\uD83C\uDFED\uD83D\uDCBB\uD83D\uDCBC\uD83D\uDD27\uD83D\uDD2C\uD83D\uDE80\uD83D\uDE92\uD83E\uDDAF-\uD83E\uDDB3\uD83E\uDDBC\uD83E\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68[\uD83C\uDFFB\uD83C\uDFFC\uD83C\uDFFE\uD83C\uDFFF]|[\uD83C\uDF3E\uD83C\uDF73\uD83C\uDF7C\uD83C\uDF93\uD83C\uDFA4\uD83C\uDFA8\uD83C\uDFEB\uD83C\uDFED\uD83D\uDCBB\uD83D\uDCBC\uD83D\uDD27\uD83D\uDD2C\uD83D\uDE80\uD83D\uDE92\uD83E\uDDAF-\uD83E\uDDB3\uD83E\uDDBC\uD83E\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68[\uD83C\uDFFB\uD83C\uDFFD-\uD83C\uDFFF]|[\uD83C\uDF3E\uD83C\uDF73\uD83C\uDF7C\uD83C\uDF93\uD83C\uDFA4\uD83C\uDFA8\uD83C\uDFEB\uD83C\uDFED\uD83D\uDCBB\uD83D\uDCBC\uD83D\uDD27\uD83D\uDD2C\uD83D\uDE80\uD83D\uDE92\uD83E\uDDAF-\uD83E\uDDB3\uD83E\uDDBC\uD83E\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68[\uD83C\uDFFC-\uD83C\uDFFF]|[\uD83C\uDF3E\uD83C\uDF73\uD83C\uDF7C\uD83C\uDF93\uD83C\uDFA4\uD83C\uDFA8\uD83C\uDFEB\uD83C\uDFED\uD83D\uDCBB\uD83D\uDCBC\uD83D\uDD27\uD83D\uDD2C\uD83D\uDE80\uD83D\uDE92\uD83E\uDDAF-\uD83E\uDDB3\uD83E\uDDBC\uD83E\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|[\uD83D\uDC68\uD83D\uDC69]\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D[\uD83D\uDC66\uD83D\uDC67])|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D[\uD83D\uDC66\uD83D\uDC67]|[\uD83D\uDC68\uD83D\uDC69]\u200D[\uD83D\uDC66\uD83D\uDC67]|[\u2695\u2696\u2708]\uFE0F|[\uD83D\uDC66\uD83D\uDC67]|[\uD83C\uDF3E\uD83C\uDF73\uD83C\uDF7C\uD83C\uDF93\uD83C\uDFA4\uD83C\uDFA8\uD83C\uDFEB\uD83C\uDFED\uD83D\uDCBB\uD83D\uDCBC\uD83D\uDD27\uD83D\uDD2C\uD83D\uDE80\uD83D\uDE92\uD83E\uDDAF-\uD83E\uDDB3\uD83E\uDDBC\uD83E\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708])\uFE0F|[\uD83C\uDFFB-\uD83C\uDFFF])|\uD83E\uDDD1(?:[\uD83C\uDFFB-\uD83C\uDFFF]\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1[\uD83C\uDFFB-\uD83C\uDFFF]|[\uD83C\uDF3E\uD83C\uDF73\uD83C\uDF7C\uD83C\uDF84\uD83C\uDF93\uD83C\uDFA4\uD83C\uDFA8\uD83C\uDFEB\uD83C\uDFED\uD83D\uDCBB\uD83D\uDCBC\uD83D\uDD27\uD83D\uDD2C\uD83D\uDE80\uD83D\uDE92\uD83E\uDDAF-\uD83E\uDDB3\uD83E\uDDBC\uD83E\uDDBD])|\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|[\uD83C\uDF3E\uD83C\uDF73\uD83C\uDF7C\uD83C\uDF84\uD83C\uDF93\uD83C\uDFA4\uD83C\uDFA8\uD83C\uDFEB\uD83C\uDFED\uD83D\uDCBB\uD83D\uDCBC\uD83D\uDD27\uD83D\uDD2C\uD83D\uDE80\uD83D\uDE92\uD83E\uDDAF-\uD83E\uDDB3\uD83E\uDDBC\uD83E\uDDBD]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D[\uD83D\uDC68\uD83D\uDC69]|[\uD83D\uDC68\uD83D\uDC69])|[\uD83C\uDF3E\uD83C\uDF73\uD83C\uDF7C\uD83C\uDF93\uD83C\uDFA4\uD83C\uDFA8\uD83C\uDFEB\uD83C\uDFED\uD83D\uDCBB\uD83D\uDCBC\uD83D\uDD27\uD83D\uDD2C\uD83D\uDE80\uD83D\uDE92\uD83E\uDDAF-\uD83E\uDDB3\uD83E\uDDBC\uD83E\uDDBD])|\uD83C\uDFFF\u200D[\uD83C\uDF3E\uD83C\uDF73\uD83C\uDF7C\uD83C\uDF93\uD83C\uDFA4\uD83C\uDFA8\uD83C\uDFEB\uD83C\uDFED\uD83D\uDCBB\uD83D\uDCBC\uD83D\uDD27\uD83D\uDD2C\uD83D\uDE80\uD83D\uDE92\uD83E\uDDAF-\uD83E\uDDB3\uD83E\uDDBC\uD83E\uDDBD]|\uD83C\uDFFE\u200D[\uD83C\uDF3E\uD83C\uDF73\uD83C\uDF7C\uD83C\uDF93\uD83C\uDFA4\uD83C\uDFA8\uD83C\uDFEB\uD83C\uDFED\uD83D\uDCBB\uD83D\uDCBC\uD83D\uDD27\uD83D\uDD2C\uD83D\uDE80\uD83D\uDE92\uD83E\uDDAF-\uD83E\uDDB3\uD83E\uDDBC\uD83E\uDDBD]|\uD83C\uDFFD\u200D[\uD83C\uDF3E\uD83C\uDF73\uD83C\uDF7C\uD83C\uDF93\uD83C\uDFA4\uD83C\uDFA8\uD83C\uDFEB\uD83C\uDFED\uD83D\uDCBB\uD83D\uDCBC\uD83D\uDD27\uD83D\uDD2C\uD83D\uDE80\uD83D\uDE92\uD83E\uDDAF-\uD83E\uDDB3\uD83E\uDDBC\uD83E\uDDBD]|\uD83C\uDFFC\u200D[\uD83C\uDF3E\uD83C\uDF73\uD83C\uDF7C\uD83C\uDF93\uD83C\uDFA4\uD83C\uDFA8\uD83C\uDFEB\uD83C\uDFED\uD83D\uDCBB\uD83D\uDCBC\uD83D\uDD27\uD83D\uDD2C\uD83D\uDE80\uD83D\uDE92\uD83E\uDDAF-\uD83E\uDDB3\uD83E\uDDBC\uD83E\uDDBD]|\uD83C\uDFFB\u200D[\uD83C\uDF3E\uD83C\uDF73\uD83C\uDF7C\uD83C\uDF93\uD83C\uDFA4\uD83C\uDFA8\uD83C\uDFEB\uD83C\uDFED\uD83D\uDCBB\uD83D\uDCBC\uD83D\uDD27\uD83D\uDD2C\uD83D\uDE80\uD83D\uDE92\uD83E\uDDAF-\uD83E\uDDB3\uD83E\uDDBC\uD83E\uDDBD])|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D[\uD83D\uDC68\uD83D\uDC69][\uD83C\uDFFB-\uD83C\uDFFE]|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D[\uD83D\uDC68\uD83D\uDC69][\uD83C\uDFFB-\uD83C\uDFFD\uD83C\uDFFF]|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D[\uD83D\uDC68\uD83D\uDC69][\uD83C\uDFFB\uD83C\uDFFC\uD83C\uDFFE\uD83C\uDFFF]|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D[\uD83D\uDC68\uD83D\uDC69][\uD83C\uDFFB\uD83C\uDFFD-\uD83C\uDFFF]|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D[\uD83D\uDC68\uD83D\uDC69][\uD83C\uDFFC-\uD83C\uDFFF]|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D[\uD83D\uDC66\uD83D\uDC67]|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83E\uDDD1(?:[\uD83C\uDFFB-\uD83C\uDFFF]\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC3B\u200D\u2744|[\uD83C\uDFC3\uD83C\uDFC4\uD83C\uDFCA\uD83D\uDC6E\uD83D\uDC70\uD83D\uDC71\uD83D\uDC73\uD83D\uDC77\uD83D\uDC81\uD83D\uDC82\uD83D\uDC86\uD83D\uDC87\uD83D\uDE45-\uD83D\uDE47\uD83D\uDE4B\uD83D\uDE4D\uD83D\uDE4E\uD83D\uDEA3\uD83D\uDEB4-\uD83D\uDEB6\uD83E\uDD26\uD83E\uDD35\uD83E\uDD37-\uD83E\uDD39\uD83E\uDD3D\uD83E\uDD3E\uD83E\uDDB8\uD83E\uDDB9\uD83E\uDDCD-\uD83E\uDDCF\uD83E\uDDD6-\uD83E\uDDDD][\uD83C\uDFFB-\uD83C\uDFFF]\u200D[\u2640\u2642]|[\u26F9\uD83C\uDFCB\uD83C\uDFCC\uD83D\uDD75](?:\uFE0F\u200D[\u2640\u2642]|[\uD83C\uDFFB-\uD83C\uDFFF]\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620|[\uD83C\uDFC3\uD83C\uDFC4\uD83C\uDFCA\uD83D\uDC6E-\uD83D\uDC71\uD83D\uDC73\uD83D\uDC77\uD83D\uDC81\uD83D\uDC82\uD83D\uDC86\uD83D\uDC87\uD83D\uDE45-\uD83D\uDE47\uD83D\uDE4B\uD83D\uDE4D\uD83D\uDE4E\uD83D\uDEA3\uD83D\uDEB4-\uD83D\uDEB6\uD83E\uDD26\uD83E\uDD35\uD83E\uDD37-\uD83E\uDD39\uD83E\uDD3C-\uD83E\uDD3E\uD83E\uDDB8\uD83E\uDDB9\uD83E\uDDCD-\uD83E\uDDCF\uD83E\uDDD6-\uD83E\uDDDF]\u200D[\u2640\u2642])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D[\uD83D\uDC66\uD83D\uDC67]|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\uD83E\uDDD1[\uD83C\uDFFB-\uD83C\uDFFF]|\uD83D\uDC69[\uD83C\uDFFB-\uD83C\uDFFF]|\uD83C\uDDFF[\uD83C\uDDE6\uD83C\uDDF2\uD83C\uDDFC]|\uD83C\uDDFE[\uD83C\uDDEA\uD83C\uDDF9]|\uD83C\uDDFC[\uD83C\uDDEB\uD83C\uDDF8]|\uD83C\uDDFB[\uD83C\uDDE6\uD83C\uDDE8\uD83C\uDDEA\uD83C\uDDEC\uD83C\uDDEE\uD83C\uDDF3\uD83C\uDDFA]|\uD83C\uDDFA[\uD83C\uDDE6\uD83C\uDDEC\uD83C\uDDF2\uD83C\uDDF3\uD83C\uDDF8\uD83C\uDDFE\uD83C\uDDFF]|\uD83C\uDDF9[\uD83C\uDDE6\uD83C\uDDE8\uD83C\uDDE9\uD83C\uDDEB-\uD83C\uDDED\uD83C\uDDEF-\uD83C\uDDF4\uD83C\uDDF7\uD83C\uDDF9\uD83C\uDDFB\uD83C\uDDFC\uD83C\uDDFF]|\uD83C\uDDF8[\uD83C\uDDE6-\uD83C\uDDEA\uD83C\uDDEC-\uD83C\uDDF4\uD83C\uDDF7-\uD83C\uDDF9\uD83C\uDDFB\uD83C\uDDFD-\uD83C\uDDFF]|\uD83C\uDDF7[\uD83C\uDDEA\uD83C\uDDF4\uD83C\uDDF8\uD83C\uDDFA\uD83C\uDDFC]|\uD83C\uDDF5[\uD83C\uDDE6\uD83C\uDDEA-\uD83C\uDDED\uD83C\uDDF0-\uD83C\uDDF3\uD83C\uDDF7-\uD83C\uDDF9\uD83C\uDDFC\uD83C\uDDFE]|\uD83C\uDDF3[\uD83C\uDDE6\uD83C\uDDE8\uD83C\uDDEA-\uD83C\uDDEC\uD83C\uDDEE\uD83C\uDDF1\uD83C\uDDF4\uD83C\uDDF5\uD83C\uDDF7\uD83C\uDDFA\uD83C\uDDFF]|\uD83C\uDDF2[\uD83C\uDDE6\uD83C\uDDE8-\uD83C\uDDED\uD83C\uDDF0-\uD83C\uDDFF]|\uD83C\uDDF1[\uD83C\uDDE6-\uD83C\uDDE8\uD83C\uDDEE\uD83C\uDDF0\uD83C\uDDF7-\uD83C\uDDFB\uD83C\uDDFE]|\uD83C\uDDF0[\uD83C\uDDEA\uD83C\uDDEC-\uD83C\uDDEE\uD83C\uDDF2\uD83C\uDDF3\uD83C\uDDF5\uD83C\uDDF7\uD83C\uDDFC\uD83C\uDDFE\uD83C\uDDFF]|\uD83C\uDDEF[\uD83C\uDDEA\uD83C\uDDF2\uD83C\uDDF4\uD83C\uDDF5]|\uD83C\uDDEE[\uD83C\uDDE8-\uD83C\uDDEA\uD83C\uDDF1-\uD83C\uDDF4\uD83C\uDDF6-\uD83C\uDDF9]|\uD83C\uDDED[\uD83C\uDDF0\uD83C\uDDF2\uD83C\uDDF3\uD83C\uDDF7\uD83C\uDDF9\uD83C\uDDFA]|\uD83C\uDDEC[\uD83C\uDDE6\uD83C\uDDE7\uD83C\uDDE9-\uD83C\uDDEE\uD83C\uDDF1-\uD83C\uDDF3\uD83C\uDDF5-\uD83C\uDDFA\uD83C\uDDFC\uD83C\uDDFE]|\uD83C\uDDEB[\uD83C\uDDEE-\uD83C\uDDF0\uD83C\uDDF2\uD83C\uDDF4\uD83C\uDDF7]|\uD83C\uDDEA[\uD83C\uDDE6\uD83C\uDDE8\uD83C\uDDEA\uD83C\uDDEC\uD83C\uDDED\uD83C\uDDF7-\uD83C\uDDFA]|\uD83C\uDDE9[\uD83C\uDDEA\uD83C\uDDEC\uD83C\uDDEF\uD83C\uDDF0\uD83C\uDDF2\uD83C\uDDF4\uD83C\uDDFF]|\uD83C\uDDE8[\uD83C\uDDE6\uD83C\uDDE8\uD83C\uDDE9\uD83C\uDDEB-\uD83C\uDDEE\uD83C\uDDF0-\uD83C\uDDF5\uD83C\uDDF7\uD83C\uDDFA-\uD83C\uDDFF]|\uD83C\uDDE7[\uD83C\uDDE6\uD83C\uDDE7\uD83C\uDDE9-\uD83C\uDDEF\uD83C\uDDF1-\uD83C\uDDF4\uD83C\uDDF6-\uD83C\uDDF9\uD83C\uDDFB\uD83C\uDDFC\uD83C\uDDFE\uD83C\uDDFF]|\uD83C\uDDE6[\uD83C\uDDE8-\uD83C\uDDEC\uD83C\uDDEE\uD83C\uDDF1\uD83C\uDDF2\uD83C\uDDF4\uD83C\uDDF6-\uD83C\uDDFA\uD83C\uDDFC\uD83C\uDDFD\uD83C\uDDFF]|[#*0-9]\uFE0F\u20E3|[\uD83C\uDFC3\uD83C\uDFC4\uD83C\uDFCA\uD83D\uDC6E\uD83D\uDC70\uD83D\uDC71\uD83D\uDC73\uD83D\uDC77\uD83D\uDC81\uD83D\uDC82\uD83D\uDC86\uD83D\uDC87\uD83D\uDE45-\uD83D\uDE47\uD83D\uDE4B\uD83D\uDE4D\uD83D\uDE4E\uD83D\uDEA3\uD83D\uDEB4-\uD83D\uDEB6\uD83E\uDD26\uD83E\uDD35\uD83E\uDD37-\uD83E\uDD39\uD83E\uDD3D\uD83E\uDD3E\uD83E\uDDB8\uD83E\uDDB9\uD83E\uDDCD-\uD83E\uDDCF\uD83E\uDDD6-\uD83E\uDDDD][\uD83C\uDFFB-\uD83C\uDFFF]|[\u26F9\uD83C\uDFCB\uD83C\uDFCC\uD83D\uDD75][\uD83C\uDFFB-\uD83C\uDFFF]|[\u261D\u270A-\u270D\uD83C\uDF85\uD83C\uDFC2\uD83C\uDFC7\uD83D\uDC42\uD83D\uDC43\uD83D\uDC46-\uD83D\uDC50\uD83D\uDC66\uD83D\uDC67\uD83D\uDC6B-\uD83D\uDC6D\uD83D\uDC72\uD83D\uDC74-\uD83D\uDC76\uD83D\uDC78\uD83D\uDC7C\uD83D\uDC83\uD83D\uDC85\uD83D\uDCAA\uD83D\uDD74\uD83D\uDD7A\uD83D\uDD90\uD83D\uDD95\uD83D\uDD96\uD83D\uDE4C\uD83D\uDE4F\uD83D\uDEC0\uD83D\uDECC\uD83E\uDD0C\uD83E\uDD0F\uD83E\uDD18-\uD83E\uDD1C\uD83E\uDD1E\uD83E\uDD1F\uD83E\uDD30-\uD83E\uDD34\uD83E\uDD36\uD83E\uDD77\uD83E\uDDB5\uD83E\uDDB6\uD83E\uDDBB\uD83E\uDDD2-\uD83E\uDDD5][\uD83C\uDFFB-\uD83C\uDFFF]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55\uD83C\uDC04\uD83C\uDCCF\uD83C\uDD8E\uD83C\uDD91-\uD83C\uDD9A\uD83C\uDDE6-\uD83C\uDDFF\uD83C\uDE01\uD83C\uDE1A\uD83C\uDE2F\uD83C\uDE32-\uD83C\uDE36\uD83C\uDE38-\uD83C\uDE3A\uD83C\uDE50\uD83C\uDE51\uD83C\uDF00-\uD83C\uDF20\uD83C\uDF2D-\uD83C\uDF35\uD83C\uDF37-\uD83C\uDF7C\uD83C\uDF7E-\uD83C\uDF93\uD83C\uDFA0-\uD83C\uDFCA\uD83C\uDFCF-\uD83C\uDFD3\uD83C\uDFE0-\uD83C\uDFF0\uD83C\uDFF4\uD83C\uDFF8-\uD83D\uDC3E\uD83D\uDC40\uD83D\uDC42-\uD83D\uDCFC\uD83D\uDCFF-\uD83D\uDD3D\uD83D\uDD4B-\uD83D\uDD4E\uD83D\uDD50-\uD83D\uDD67\uD83D\uDD7A\uD83D\uDD95\uD83D\uDD96\uD83D\uDDA4\uD83D\uDDFB-\uD83D\uDE4F\uD83D\uDE80-\uD83D\uDEC5\uD83D\uDECC\uD83D\uDED0-\uD83D\uDED2\uD83D\uDED5-\uD83D\uDED7\uD83D\uDEEB\uD83D\uDEEC\uD83D\uDEF4-\uD83D\uDEFC\uD83D\uDFE0-\uD83D\uDFEB\uD83E\uDD0C-\uD83E\uDD3A\uD83E\uDD3C-\uD83E\uDD45\uD83E\uDD47-\uD83E\uDD78\uD83E\uDD7A-\uD83E\uDDCB\uD83E\uDDCD-\uD83E\uDDFF\uD83E\uDE70-\uD83E\uDE74\uD83E\uDE78-\uD83E\uDE7A\uD83E\uDE80-\uD83E\uDE86\uD83E\uDE90-\uD83E\uDEA8\uD83E\uDEB0-\uD83E\uDEB6\uD83E\uDEC0-\uD83E\uDEC2\uD83E\uDED0-\uD83E\uDED6]|[#*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299\uD83C\uDC04\uD83C\uDCCF\uD83C\uDD70\uD83C\uDD71\uD83C\uDD7E\uD83C\uDD7F\uD83C\uDD8E\uD83C\uDD91-\uD83C\uDD9A\uD83C\uDDE6-\uD83C\uDDFF\uD83C\uDE01\uD83C\uDE02\uD83C\uDE1A\uD83C\uDE2F\uD83C\uDE32-\uD83C\uDE3A\uD83C\uDE50\uD83C\uDE51\uD83C\uDF00-\uD83C\uDF21\uD83C\uDF24-\uD83C\uDF93\uD83C\uDF96\uD83C\uDF97\uD83C\uDF99-\uD83C\uDF9B\uD83C\uDF9E-\uD83C\uDFF0\uD83C\uDFF3-\uD83C\uDFF5\uD83C\uDFF7-\uD83D\uDCFD\uD83D\uDCFF-\uD83D\uDD3D\uD83D\uDD49-\uD83D\uDD4E\uD83D\uDD50-\uD83D\uDD67\uD83D\uDD6F\uD83D\uDD70\uD83D\uDD73-\uD83D\uDD7A\uD83D\uDD87\uD83D\uDD8A-\uD83D\uDD8D\uD83D\uDD90\uD83D\uDD95\uD83D\uDD96\uD83D\uDDA4\uD83D\uDDA5\uD83D\uDDA8\uD83D\uDDB1\uD83D\uDDB2\uD83D\uDDBC\uD83D\uDDC2-\uD83D\uDDC4\uD83D\uDDD1-\uD83D\uDDD3\uD83D\uDDDC-\uD83D\uDDDE\uD83D\uDDE1\uD83D\uDDE3\uD83D\uDDE8\uD83D\uDDEF\uD83D\uDDF3\uD83D\uDDFA-\uD83D\uDE4F\uD83D\uDE80-\uD83D\uDEC5\uD83D\uDECB-\uD83D\uDED2\uD83D\uDED5-\uD83D\uDED7\uD83D\uDEE0-\uD83D\uDEE5\uD83D\uDEE9\uD83D\uDEEB\uD83D\uDEEC\uD83D\uDEF0\uD83D\uDEF3-\uD83D\uDEFC\uD83D\uDFE0-\uD83D\uDFEB\uD83E\uDD0C-\uD83E\uDD3A\uD83E\uDD3C-\uD83E\uDD45\uD83E\uDD47-\uD83E\uDD78\uD83E\uDD7A-\uD83E\uDDCB\uD83E\uDDCD-\uD83E\uDDFF\uD83E\uDE70-\uD83E\uDE74\uD83E\uDE78-\uD83E\uDE7A\uD83E\uDE80-\uD83E\uDE86\uD83E\uDE90-\uD83E\uDEA8\uD83E\uDEB0-\uD83E\uDEB6\uD83E\uDEC0-\uD83E\uDEC2\uD83E\uDED0-\uD83E\uDED6]\uFE0F|[\u261D\u26F9\u270A-\u270D\uD83C\uDF85\uD83C\uDFC2-\uD83C\uDFC4\uD83C\uDFC7\uD83C\uDFCA-\uD83C\uDFCC\uD83D\uDC42\uD83D\uDC43\uD83D\uDC46-\uD83D\uDC50\uD83D\uDC66-\uD83D\uDC78\uD83D\uDC7C\uD83D\uDC81-\uD83D\uDC83\uD83D\uDC85-\uD83D\uDC87\uD83D\uDC8F\uD83D\uDC91\uD83D\uDCAA\uD83D\uDD74\uD83D\uDD75\uD83D\uDD7A\uD83D\uDD90\uD83D\uDD95\uD83D\uDD96\uD83D\uDE45-\uD83D\uDE47\uD83D\uDE4B-\uD83D\uDE4F\uD83D\uDEA3\uD83D\uDEB4-\uD83D\uDEB6\uD83D\uDEC0\uD83D\uDECC\uD83E\uDD0C\uD83E\uDD0F\uD83E\uDD18-\uD83E\uDD1F\uD83E\uDD26\uD83E\uDD30-\uD83E\uDD39\uD83E\uDD3C-\uD83E\uDD3E\uD83E\uDD77\uD83E\uDDB5\uD83E\uDDB6\uD83E\uDDB8\uD83E\uDDB9\uD83E\uDDBB\uD83E\uDDCD-\uD83E\uDDCF\uD83E\uDDD1-\uD83E\uDDDD]/gu;
	}

	onFinish() {
		this.payloadItems.forEach((item) => {
			item.attributes = this.cleanAttributes(item);
			item.attributes.push({ key: "_main_item", value: this.mainItem.merchandiseId });

			// Add card-related attributes
			if (item.merchandiseId === this.cardVariantId && this.cardMessage) {
				item.attributes.push(
					{ key: "_cardHeader", value: "<p><br></p>" },
					{ key: "_cardFooter", value: "<p><br></p>" },
					{ key: "_cardBody", value: this.cardMessage.html },
					{ key: "_cardContent", value: this.cardMessage.plainText }
				);
			}
		});

		this.storeSteps();

		this.callback(this.payloadItems);

		if (!this.scrollWasLocked) this.documentHtml.classList.remove("overflow-hidden");
		if (this.mainContainer) this.mainContainer.remove();
	}

	onAbort() {
		console.log("onAbort");
		// remove all screens
		if (!this.scrollWasLocked) this.documentHtml.classList.remove("overflow-hidden");
		this.mainContainer.remove();
		this.callback(null);
	}

	// TODO: how to use...
	start({ mainItem, initialPayload, thumbnail, steps, activeStep, abortBtnText, saveBtnText }, callback) {
		this.callback = callback;

		if (!mainItem || !mainItem.merchandiseId || !steps || !Array.isArray(steps) || steps.length === 0) {
			// Nothing to show
			console.log("No steps available");
			this.onFinish();
			return;
		}

		// Templates
		this.stepTemplate = document.getElementById("gift-builder-step");
		this.stepBtnTemplate = document.getElementById("gift-builder-step-button");
		this.gridItemTemplate = document.getElementById("gift-builder-grid-item");
		this.gridContentTemplate = document.getElementById("gift-builder-grid-content");
		this.cardSelectorTemplate = document.getElementById("gift-builder-card-selector");

		// initial status
		this.mainItem = mainItem;
		this.thumbnail = thumbnail;
		this.abortBtnText = abortBtnText || "Close";
		this.saveBtnText = saveBtnText || "Checkout";
		this.initialPrice = parseFloat(mainItem.price);
		this.allSteps = steps;
		this.steps = steps.filter((s) => !s.hideStep);
		this.activeStep = activeStep || 0;
		this.payloadItems = initialPayload || [];
		this.renderedItems = [];

		const containerTemplate = document.getElementById("gift-builder-wrapper");
		this.mainContainer = containerTemplate.content.cloneNode(true).querySelector("div");
		this.stepsHolder = this.mainContainer.querySelector(".steps");

		document.body.appendChild(this.mainContainer);
		this.scrollWasLocked = this.documentHtml.classList.contains("overflow-hidden");
		if (!this.scrollWasLocked) this.documentHtml.classList.add("overflow-hidden");

		this.renderSteps();
	}

	toggleLoading(show, container) {
		if (!container) return;
		const loadingEl = container.querySelector(".loading");
		loadingEl.classList.toggle("hidden", !show);
	}

	cleanAttributes(item) {
		// removes gift builder attributes keeping any others
		const removeKeys = new Set(["_cardContent", "_cardHeader", "_main_item", "_cardBody", "_cardFooter"]);

		return item.attributes ? item.attributes.filter((attr) => !removeKeys.has(attr.key)) : [];
	}

	storeSteps() {
		if (!this.mainItem) return;

		const mainItemId = this.mainItem.merchandiseId;
		let stepsData = [];

		try {
			const stored = window.localStorage.getItem(this.giftBuilderStorageKey);
			stepsData = stored ? JSON.parse(stored) : [];
			if (!Array.isArray(stepsData)) stepsData = [];
		} catch (e) {
			console.log("Failed to parse giftBuilderSteps:", e);
			stepsData = [];
		}

		// Some steps are hidden in the PDP but not in the cart
		const unhideSteps = (steps) =>
			steps.map((step) => ({
				...step,
				hideStep: false,
			}));

		const newEntry = { mainItemId, steps: unhideSteps(this.allSteps) };
		const index = stepsData.findIndex((entry) => entry.mainItemId === mainItemId);

		if (index >= 0) {
			stepsData[index] = newEntry;
		} else {
			stepsData.push(newEntry);
		}

		try {
			window.localStorage.setItem(this.giftBuilderStorageKey, JSON.stringify(stepsData));
		} catch (e) {
			console.log("Failed to save giftBuilderSteps:", e);
		}
	}

	loadStoredSteps(mainItemId) {
		try {
			const stored = window.localStorage.getItem(this.giftBuilderStorageKey);
			if (!stored) return null;

			const stepsData = JSON.parse(stored);
			if (!Array.isArray(stepsData)) return null;

			const storedSteps = stepsData.find((entry) => entry.mainItemId === mainItemId);
			return storedSteps?.steps || null;
		} catch (e) {
			console.log("Failed to load giftBuilderSteps:", e);
			return null;
		}
	}

	renderHeader(container, index, step) {
		const stepBtnTemplate = this.stepBtnTemplate.content.cloneNode(true);
		const stepButton = stepBtnTemplate.querySelector("button");
		const stepsContainer = container.querySelector(".steps-container");

		if (this.thumbnail) {
			const thumbnail = container.querySelector(".header .thumbnail img");
			thumbnail.src = this.thumbnail;
		} else {
			const thumbnailDiv = container.querySelector(".header .thumbnail");
			thumbnailDiv.remove();
		}

		const titleEl = container.querySelector(".header .title");
		const subTitleEl = container.querySelector(".header .subtitle");
		titleEl.innerText = step.title;
		subTitleEl.innerText = step.message || "";

		// build header step btns
		if (this.steps.length > 1) {
			for (let i = 0; i < this.steps.length; i += 1) {
				const btn = stepButton.cloneNode(true);
				if (i <= index) btn.setAttribute("data-active", true);
				if (this.steps[i + 1]) {
					btn.querySelector(".space").classList.remove("hidden");
				}
				btn.querySelector("div").innerText = i + 1;
				btn.setAttribute("data-step-n", i);
				btn.addEventListener("click", this.changeStepScreen.bind(this, i));
				stepsContainer.appendChild(btn);
			}
		}

		const changeBnt = container.querySelector(".header .action button");
		changeBnt.innerText = this.abortBtnText;
		changeBnt.addEventListener("click", this.onAbort.bind(this));
	}

	renderFooter(container, index) {
		// Screen footer continue button
		const footerBtn = container.querySelector(".footer button");
		const containerType = container.getAttribute("data-type");

		if (containerType === "cards") {
			footerBtn.innerText = "Continue";
			// Track event handler to allow event switching later
			this.cardFooterContinueBoundEvent = this.toggleCardMessageScreen.bind(this, container);
			this.cardFooterFinishBoundEvent = this.onFinish.bind(this, container);
			footerBtn.addEventListener("click", this.cardFooterContinueBoundEvent);
		} else if (this.steps.length > index + 1) {
			footerBtn.innerText = "Continue";
			footerBtn.addEventListener("click", this.changeStepScreen.bind(this, index + 1));
		} else {
			footerBtn.innerText = this.saveBtnText;
			footerBtn.addEventListener("click", this.onFinish.bind(this));
		}
	}

	updateFooter() {
		// Updates total price in all screens
		const priceEls = Array.from(this.mainContainer.querySelectorAll(".footer div span"));
		const totalPrice = this.payloadItems.reduce((a, c) => a + parseFloat(c.price), this.initialPrice);
		const oldPrice = priceEls[0].getAttribute("data-total");
		if (!oldPrice || parseFloat(oldPrice) !== totalPrice) {
			priceEls.forEach((el) => {
				el.setAttribute("data-total", totalPrice);
				el.innerText = `£${totalPrice.toFixed(2)}`;
				el.parentNode.classList.add("text-yellow-400");
				setTimeout(() => {
					el.parentNode.classList.remove("text-yellow-400");
				}, 500);
			});
		}
	}

	renderContent(container, step) {
		// Cards will use a different render
		if (step.type === "cards") {
			this.renderCardSelector(container);
			return;
		}

		this.renderItems(container, step);
	}

	renderSteps() {
		this.steps.forEach((step, index) => {
			const stepTemplate = this.stepTemplate.content.cloneNode(true);
			const container = stepTemplate.querySelector("div");

			container.setAttribute("id", `gift-builder-step-${index}`);
			container.setAttribute("data-type", step.type);

			this.renderHeader(container, index, step);
			this.renderFooter(container, index);

			// render step content
			this.renderContent(container, step);

			if (index === 0) {
				setTimeout(() => {
					container.setAttribute("aria-expanded", "true");
				}, 500);
			} else {
				// remove transaction from next screens
				container.classList.remove("transition-transform", "duration-250");
			}

			this.stepsHolder.appendChild(container);
		});

		this.updateFooter();
		this.changeStepScreen(this.activeStep);
	}

	changeStepScreen(screenIndex) {
		const stepScreens = Array.from(document.querySelectorAll(".gift-builder-step"));

		stepScreens.forEach((s) => {
			const id = s.getAttribute("id");
			if (id !== `gift-builder-step-0`) s.setAttribute("aria-expanded", id === `gift-builder-step-${screenIndex}`);
			s.setAttribute("data-active", id === `gift-builder-step-${screenIndex}`);
		});

		// scroll first selected item to view
		const firstSelectedItem = this.mainContainer.querySelector(
			".gift-builder-step[data-active='true'] .content button[data-selected]"
		);
		if (firstSelectedItem) firstSelectedItem.scrollIntoView();

		this.activeStep = screenIndex;
		this.updateFooter();
	}

	buildItem(item, isCard = false) {
		const itemPrice = item.price?.amount || item.price;
		const imageUrl = item.image?.url || item.cardImg.url;

		const itemEl = this.gridItemTemplate.content.cloneNode(true);
		const button = itemEl.querySelector("button");
		const image = itemEl.querySelector("button img");
		const title = itemEl.querySelector("button .title");
		const price = itemEl.querySelector("button .price");
		image.alt = item.title;
		title.innerText = item.title;
		price.innerText = `£${Number(itemPrice).toFixed(2)}`;
		button.setAttribute("data-variant-id", item.id);
		button.setAttribute("data-price", itemPrice);
		button.setAttribute("data-category", item.productType);
		button.setAttribute("data-sku", item.sku);

		if (isCard) {
			image.classList.add("aspect-[210/297]");
			title.parentNode.classList.remove("justify-between");
			title.parentNode.classList.add("flex-col", "items-start");
			price.classList.add("mt-auto");
			price.classList.remove("pl-2");
			image.src = imageUrl.replace("_460x460_crop_center", "_280x280");
			if (!item.id) {
				price.innerText = "";
			}
		} else {
			image.src = imageUrl.replace("_460x460_crop_center", "_280x280_crop_center");
		}

		if (this.payloadItems.find((pi) => pi.merchandiseId === item.id)) {
			// pre-select items already in payload
			button.setAttribute("data-selected", "data-selected");
		}

		if (this.renderedItems.includes(item.sku)) {
			// hide duplicated items.
			button.classList.add("hidden");
		}

		this.renderedItems.push(item.sku);
		return button;
	}

	renderItems(container, step) {
		if (!step && !Array.isArray(step.items)) return;
		const contentEl = container.querySelector(".content");
		const contentContainer = this.gridContentTemplate.content.cloneNode(true);
		const grid = contentContainer.querySelector("div");
		const categories = []; // used to filter

		step.items.forEach((item) => {
			if (item.available) {
				categories.push(item.productType);
				const itemEl = this.buildItem(item);
				itemEl.addEventListener("click", this.handleItemClick.bind(this));
				grid.appendChild(itemEl);
			}
		});

		this.renderCategories(categories, container);
		contentEl.appendChild(contentContainer);
	}

	selectDefaultCard(defaultCardSku, cardsHolder) {
		const defaultCardEl = cardsHolder.querySelector(`button[data-sku="${defaultCardSku}"]`);
		if (!defaultCardEl) return;
		// Select default card
		const cardId = defaultCardEl.getAttribute("data-variant-id");
		const cardPrice = parseFloat(defaultCardEl.getAttribute("data-price") || 0);
		defaultCardEl.setAttribute("data-selected", "data-selected");

		// add default card to payload
		this.cardVariantId = cardId;
		this.payloadItems.push({
			merchandiseId: cardId,
			quantity: 1,
			price: cardPrice,
		});

		// Move default card to begin
		cardsHolder.prepend(defaultCardEl);
	}

	handleNoCard() {
		// No card -> remove card from payload and call onFinish
		const cardIndex = this.payloadItems.findIndex((i) => i?.merchandiseId === this.cardVariantId);
		if (cardIndex >= 0) {
			this.payloadItems.splice(cardIndex, 1);
			this.cardVariantId = null;
		}
		this.onFinish();
	}

	/* Card methods */
	async loadCardSelector(callback) {
		const request = await super.asyncRequest({
			url: this.cardsUrl,
			headers: { "Content-Type": "application/json;charset=UTF-8" },
			method: "GET",
		});

		if (!request || request.status !== 200 || !request.response) {
			throw new Error(`Can't fetch cards from url: ${this.cardsUrl}`);
		}

		try {
			const cardsObj = JSON.parse(request.response);

			// Load quill files if not available
			if (typeof Quill !== "function") {
				const script = document.createElement("script");
				script.src = "/assets/js/quill.js";
				const styles = document.createElement("link");
				styles.setAttribute("rel", "stylesheet");
				styles.setAttribute("href", "/assets/css/quill.snow.css");
				document.body.prepend(script);
				document.head.appendChild(styles);

				script.onload = () => callback(cardsObj);
			} else {
				callback(cardsObj);
			}
		} catch (error) {
			console.log("Error loading card selector files", error);
			throw error;
		}
	}

	renderCardSelector(container) {
		const sortedCards = (cards) => {
			if (!this.sortCards) return cards;
			return cards.sort(([a], [b]) => {
				if (a.price.amount < b.price.amount) return 1;
				if (b.price.amount < a.price.amount) return -1;
				return 0;
			});
		};

		const contentEl = container.querySelector(".content");
		this.toggleLoading(true, container);
		this.loadCardSelector((cardsObj) => {
			const cardSelector = this.cardSelectorTemplate.content.cloneNode(true);
			const cardsHolder = cardSelector.querySelector(".cards");
			const messageHolder = cardSelector.querySelector(".message");

			contentEl.appendChild(cardSelector);

			const categories = [];
			const cards = [];

			// Prepare cards/categories
			cardsObj.cards.forEach((category) => {
				if (category.availableForSale) {
					let categoryItemQty = 0;
					category.variants.nodes.forEach((item) => {
						if (item.availableForSale) {
							cards.push([item, category.title]);
							categoryItemQty += 1;
						}
					});
					if (categoryItemQty > 0) categories.push(category.title);
				}
			});

			let hasCardSelected = false;
			sortedCards(cards).forEach(([item, categoryTitle]) => {
				// Check if initialPayload contains a card
				const selectedCardIndex = this.payloadItems.findIndex((pi) => pi.merchandiseId === item.id);
				if (selectedCardIndex >= 0) {
					const cardAttr = this.payloadItems[selectedCardIndex].attributes;
					if (cardAttr) {
						const cardBody = cardAttr.find((attr) => attr.key === "_cardBody");
						const cardContent = cardAttr.find((attr) => attr.key === "_cardContent");
						if (cardBody && cardContent) {
							this.cardMessage = {
								html: cardBody.value,
								plainText: cardContent.value,
							};
						}
					}

					this.cardVariantId = item.id;
					hasCardSelected = true;
				}

				const itemEl = this.buildItem(item, true);
				itemEl.setAttribute("data-category", categoryTitle); // General cards, Birthday cards..
				itemEl.setAttribute("data-product-category", "Greeting Card"); // GTM trigger selector
				itemEl.setAttribute("data-variant", item.title); // GTM param
				itemEl.addEventListener("click", this.handleCardClick.bind(this, container));
				cardsHolder.appendChild(itemEl);
			});

			// if no card selected, pre-select default card.
			const { defaultCardSku } = cardsObj.cardDetails;
			if (!hasCardSelected && defaultCardSku) {
				this.selectDefaultCard(defaultCardSku, cardsHolder);
			}

			// Go back from message to cards design
			const changeDesignBt = messageHolder.querySelector(".change-design");
			changeDesignBt.addEventListener("click", this.toggleCardMessageScreen.bind(this, container));

			// handle no card
			const noCardButton = container.querySelector(".no-card-option button");
			noCardButton.addEventListener("click", this.handleNoCard.bind(this));

			// Allow filter only free cards
			const onlyFreeToggle = container.querySelector(".only-free-filter input");
			onlyFreeToggle.parentNode.parentNode.classList.remove("hidden");
			onlyFreeToggle.addEventListener("change", this.handleFilterCategory.bind(this, container));

			this.renderCategories(categories, container);

			// Setup and starts Quill.js
			const Font = Quill.import("formats/font");
			const Delta = Quill.import("delta");

			Font.whitelist = ["LibreBaskerville", "BrownLLPanTT", "Moderat"];
			Quill.register(Font, true);

			this.editor = new Quill("#ql-editor", {
				modules: {
					toolbar: "#ql-toolbar",
				},
				placeholder: "Write your message here or leave it blank.",
				theme: "snow",
			});

			const qlEditorEl = this.editor.root;

			const moveMessageAreaUp = () => {
				const amountToScroll = 125;

				window.scrollBy({
					top: amountToScroll,
					behavior: "smooth",
				});
			};

			qlEditorEl.addEventListener("focus", () => {
				if (window.innerWidth >= 768) return;
			  setTimeout(moveMessageAreaUp, 250);
			});

			// Fill previous message if available
			if (this.cardMessage) {
				this.editor.root.innerHTML = this.cardMessage.html;
			}

			// Force paste as plain text
			this.editor.clipboard.addMatcher(Node.ELEMENT_NODE, (node) => new Delta().insert(node.innerText));

			// Handle events
			this.editor.on("editor-change", this.onCardEditorChange.bind(this, messageHolder));
			this.toggleLoading(false, container);
		});
	}

	onCardEditorChange(messageHolder, eventName, ...args) {
		// Remove emojis
		if (this.cleanEmojis && eventName === "text-change" && args[2] === "user") {
			if (this.editor.getText().match(this.emojiRegex)) {
				this.editor.root.innerHTML = this.editor.root.innerHTML.replace(this.emojiRegex, "");
			}
		}

		// trims the message
		if (this.editor.getLength() > this.maxMessageLength) {
			this.editor.deleteText(this.maxMessageLength, this.editor.getLength());
		}

		// Updates counter
		const messageCount = messageHolder.querySelector(".counter");
		messageCount.innerText = `${this.editor.getLength() - 1}/${this.maxMessageLength}`;
		messageCount.classList.toggle("text-alert", this.editor.getLength() - 1 >= this.maxMessageLength);

		this.cardMessage = {
			html: this.editor.root.innerHTML,
			plainText: this.editor.getText(),
		};
	}

	// eslint-disable-next-line class-methods-use-this
	toggleCardMessageScreen(container) {
		const updateCheckouButton = (finalStep) => {
			const footerBtn = container.querySelector(".footer button");

			if (finalStep) {
				footerBtn.innerText = this.saveBtnText;
				footerBtn.removeEventListener("click", this.cardFooterContinueBoundEvent);
				footerBtn.addEventListener("click", this.cardFooterFinishBoundEvent);
			} else {
				footerBtn.innerText = "Continue";

				footerBtn.removeEventListener("click", this.cardFooterFinishBoundEvent);
				footerBtn.addEventListener("click", this.cardFooterContinueBoundEvent);
			}
		};

		const content = container.querySelector(".content");
		const categories = container.querySelector(".categories");
		const headerTitle = container.querySelector(".header-title");
		const cardsContainer = content.querySelector(".group");

		if (cardsContainer.getAttribute("data-card-selected")) {
			cardsContainer.removeAttribute("data-card-selected");
			content.classList.add("overflow-y-scroll");
			categories.classList.remove("hidden");
			headerTitle.classList.remove("hidden");
			updateCheckouButton(false);
		} else {
			// Allows user's click show its feedback before change screen
			setTimeout(() => {
				cardsContainer.setAttribute("data-card-selected", "true");
				content.classList.remove("overflow-y-scroll");
				categories.classList.add("hidden");
				headerTitle.classList.add("hidden");
				updateCheckouButton(true);
			}, this.autoAdvanceTime);
		}
	}

	handleCardClick(container, e) {
		const currentCardSelected = container.querySelector(".cards button[data-selected]");
		const variantId = e.currentTarget.getAttribute("data-variant-id");
		if (!currentCardSelected || currentCardSelected !== e.currentTarget) {
			// Allow user select again the same card without deselect it
			this.cardVariantId = variantId;

			this.handleItemClick(e);
		}

		if (variantId && variantId !== "false") this.toggleCardMessageScreen(container);
	}

	/* End card methods */

	handleItemClick({ currentTarget }) {
		const variantId = currentTarget.getAttribute("data-variant-id");
		const isSelected = currentTarget.toggleAttribute("data-selected");

		if (isSelected) {
			// Variant id can be false/undefined for "No Option"
			if (variantId && variantId !== "false") {
				this.payloadItems.push({
					merchandiseId: variantId,
					quantity: 1,
					price: parseFloat(currentTarget.getAttribute("data-price") || 0),
				});
			}

			// If not allowed to select multiple items, unselect other items and remove from payload
			const { allowMultiple = true } = this.steps[this.activeStep];
			if (!allowMultiple) {
				const selectedItems = Array.from(currentTarget.parentNode.querySelectorAll("[data-selected]"));
				selectedItems.forEach((si) => {
					// unselect others
					if (si !== currentTarget) {
						const siId = si.getAttribute("data-variant-id");
						const siIndex = this.payloadItems.findIndex((i) => i?.merchandiseId === siId);
						if (siIndex >= 0) this.payloadItems.splice(siIndex, 1);
						si.removeAttribute("data-selected");
					}
				});

				setTimeout(() => {
					if (this.activeStep < this.steps.length - 1 && this.steps[this.activeStep].type !== "cards") {
						this.changeStepScreen(this.activeStep + 1);
					}
				}, this.autoAdvanceTime);
			}
		} else {
			const itemIndex = this.payloadItems.findIndex((i) => i?.merchandiseId === variantId);
			if (itemIndex >= 0) this.payloadItems.splice(itemIndex, 1);
		}

		this.updateFooter();
	}

	renderCategories(categories, container) {
		const contentEl = container.querySelector(".content");
		const dedupItems = Array.from(new Set(categories));

		const categoriesContainer = contentEl.parentNode.querySelector(".categories");
		if (dedupItems.length <= 1) return;

		categoriesContainer.classList.remove("hidden");

		const filterOptList = categoriesContainer.querySelector("ul");

		dedupItems.unshift("All");

		dedupItems.forEach((item) => {
			const liEl = document.createElement("li");
			const buttonEl = document.createElement("button");
			buttonEl.classList.add(
				"px-4",
				"py-1",
				"text-gray-500",
				"data-[selected]:font-semibold",
				"data-[selected]:text-primary"
			);
			buttonEl.innerText = item;
			if (item === "All") {
				buttonEl.setAttribute("data-category", "*");
				buttonEl.setAttribute("data-selected", "data-selected");
			} else {
				buttonEl.setAttribute("data-category", item);
			}
			liEl.appendChild(buttonEl);
			filterOptList.appendChild(liEl);
			buttonEl.addEventListener("click", this.handleFilterCategory.bind(this, container));
		});

		this.handleScrollCategories(container);
	}

	// eslint-disable-next-line class-methods-use-this
	handleFilterCategory(container, { currentTarget }) {
		this.renderedItems = [];
		const contentEl = container.querySelector(".content");
		const categoriesEl = contentEl.parentNode.querySelector(".categories");
		const prevSelected = categoriesEl.querySelector("ul li button[data-selected]");
		const onlyFree = categoriesEl.querySelector(".only-free-filter input");

		if (currentTarget === onlyFree) {
			// Refilter with the same category selected
			// eslint-disable-next-line no-param-reassign
			currentTarget = prevSelected;
		}

		// Toggles active filter option
		const filterOptions = Array.from(categoriesEl.querySelectorAll("ul li button"));
		filterOptions.forEach((btn) => {
			if (btn === currentTarget) {
				btn.setAttribute("data-selected", "data-selected");
			} else {
				btn.removeAttribute("data-selected");
			}
		});

		// show/hide items based on selected category
		const category = currentTarget.getAttribute("data-category");
		const items = Array.from(contentEl.querySelectorAll(".items button"));
		items.forEach((item) => {
			const itemSku = item.getAttribute("data-sku");
			const itemCategory = item.getAttribute("data-category");

			if (category === "*" || category === itemCategory) {
				if (onlyFree.checked && parseFloat(item.getAttribute("data-price")) !== 0) {
					item.classList.add("hidden");
				} else {
					item.classList.remove("hidden");
				}
			} else {
				item.classList.add("hidden");
			}

			if (category === "*" && this.renderedItems.includes(itemSku)) {
				item.classList.add("hidden");
			}

			this.renderedItems.push(itemSku);
		});
	}

	// eslint-disable-next-line class-methods-use-this
	handleScrollCategories(container) {
		const categoryList = container.querySelector(".category-list");
		const scrollLeft = container.querySelector(".scroll-left");
		const scrollRight = container.querySelector(".scroll-right");

		function updateArrows() {
			// Disable left if at start
			if (categoryList.scrollLeft <= 0) {
				scrollLeft.disabled = true;
				scrollLeft.classList.add("opacity-50", "cursor-not-allowed");
			} else {
				scrollLeft.disabled = false;
				scrollLeft.classList.remove("opacity-50", "cursor-not-allowed");
			}

			// Disable right if at end
			if (categoryList.scrollLeft + categoryList.clientWidth >= categoryList.scrollWidth) {
				scrollRight.disabled = true;
				scrollRight.classList.add("opacity-50", "cursor-not-allowed");
			} else {
				scrollRight.disabled = false;
				scrollRight.classList.remove("opacity-50", "cursor-not-allowed");
			}
		}

		scrollLeft.addEventListener("click", () => {
			const scrollAmount = categoryList.clientWidth / 3;
			categoryList.scrollBy({ left: -scrollAmount, behavior: "smooth" });
		});

		scrollRight.addEventListener("click", () => {
			const scrollAmount = categoryList.clientWidth / 3;
			categoryList.scrollBy({ left: scrollAmount, behavior: "smooth" });
		});

		categoryList.addEventListener("scroll", updateArrows);
	}
}
